import {CanActivate, Router} from "@angular/router";
import {Http} from "@angular/http";
import {environment} from "../../environments/environment";
import {Observable} from "rxjs";
import {Injectable} from "@angular/core";
import {Location} from '@angular/common';
import {UtilService} from "./util.service";
/**
 * Created by nijin on 31/7/17.
 */

@Injectable()
export class ServerStatusGuard implements CanActivate{

  constructor(private http: Http,
              private router: Router,
              private utilService: UtilService){

  }

  canActivate(){
    if(this.utilService.isOnline()) {
      return this.http.get(environment.serviceBase+'/health')
        .map(e => {
          this.router.navigate(['/things']);
          return false;
        }).catch(() => {
          return Observable.of(true);
        });
    }
    else {
      this.router.navigate(['/things']);
      return false;
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/auth/server-status.guard.ts